import {DisplayOption} from '@/components/interfaces/ComponentOptions';
import {HTTP} from '@/services/HttpServices';
import {
    DvdOrderCheckoutParameters,
    DvdOrderDetails,
    DvdReceiptParameters,
    PublicDvdSearchResults,
    SportEventDvd,
    State
} from '@/dvd-orders/DvdModel';

export function getGenders(): Promise<DisplayOption[]> {
    return HTTP.get('/public/genders');
}

export function getStates(): Promise<State[]> {
    return HTTP.get('/public/states');
}

export function searchDvdOrders(searchText: string, year: number, page: number, size: number): Promise<PublicDvdSearchResults> {
    return HTTP.get(`/public/dvd-orders/search?searchText=${searchText}&year=${year}&page=${page}&size=${size}`);
}

export function getEventDvd(eventId: number): Promise<SportEventDvd> {
    return HTTP.get(`/public/dvd-orders/event/${eventId}`);
}

export function getStandaloneDvd(dvdId: number): Promise<SportEventDvd> {
    return HTTP.get(`/public/dvd-orders/standalone/${dvdId}`);
}

export function submitOrderToAPI(order: DvdOrderDetails): Promise<DvdOrderCheckoutParameters> {
    return HTTP.post(`/public/dvd-orders`, order);
}

export function calculateTaxes(order: DvdOrderDetails): Promise<{taxAmount: string}> {
    return HTTP.post(`/public/dvd-orders/taxes`, order);
}

export function verifyOrderPaid(receipt: DvdReceiptParameters): Promise<{ success: boolean }> {
    return HTTP.post('/public/dvd-orders/verification', receipt);
}
